"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketEntryHistoryList = void 0;
var TimeUtil_1 = require("../../utils/TimeUtil");
var TicketEntryHistoryList = /** @class */ (function (_super) {
    __extends(TicketEntryHistoryList, _super);
    function TicketEntryHistoryList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getEnteredTimeConverted = function () {
            var ticketEntryHistoryList = new TicketEntryHistoryList();
            if (_this.length > 0) {
                _this.forEach(function (x) {
                    x.enteredDateConverted = TimeUtil_1.zonedDateTimeFor(x.enteredTime).format('MMM Do, YYYY');
                    x.enteredTimeConverted = TimeUtil_1.zonedDateTimeFor(x.enteredTime).format('hh:mm a');
                    if (x.ticket.bookNumber && x.ticket.ticketNumber) {
                        x.barcodeDisplayValue = x.ticket.gameNumber + "-" + x.ticket.bookNumber + "-" + x.ticket.ticketNumber + "-" + x.ticket.validationCode;
                    }
                    else if (x.ticket.entryCode) {
                        var pattern = '#####-#####-#####-#####-#####';
                        var entryCode_1 = !!x.ticket.entryCode ? x.ticket.entryCode : '';
                        var i_1 = 0;
                        x.barcodeDisplayValue = pattern.replace(/#/g, function () { return entryCode_1[i_1++]; });
                    }
                    else {
                        x.barcodeDisplayValue = x.ticket.transactionId;
                        x.isOnlineEntry = true;
                    }
                    x.prizes.sort(function (a, b) {
                        if (a.prizeType < b.prizeType) {
                            return -1;
                        }
                        if (a.prizeType > b.prizeType) {
                            return 1;
                        }
                        return 0;
                    });
                    ticketEntryHistoryList.push(x);
                });
            }
            return ticketEntryHistoryList;
        };
        return _this;
    }
    return TicketEntryHistoryList;
}(Array));
exports.TicketEntryHistoryList = TicketEntryHistoryList;
//# sourceMappingURL=TicketEntryHistoryList.js.map